var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurvedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 59,
    fill: "none",
    viewBox: "0 0 150 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBBBF",
    d: "m39.938 39.699-.597.853.597-.853Zm104.749.617c.51.173.731.729.493 1.242l-3.88 8.353c-.238.513-.845.788-1.356.615-.51-.174-.731-.73-.493-1.242l3.449-7.425-7.394-2.509c-.511-.173-.732-.729-.493-1.241.238-.513.844-.788 1.355-.615l8.319 2.822ZM11.317.57c1.21 6.496 5.324 14.219 10.779 21.277 5.447 7.05 12.153 13.336 18.439 16.999l-1.194 1.706c-6.53-3.806-13.393-10.262-18.93-17.429-5.532-7.158-9.823-15.129-11.104-22.006l2.01-.547Zm29.218 38.276c30.745 17.917 72.791 15.387 103.372 1.52l.697 1.756c-31.112 14.108-73.886 16.715-105.263-1.57l1.194-1.706Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default __webpack_public_path__ + "static/media/curved-arrow.bb9f3e2537d2ad4a5f59651e8d618fa0.svg";
export { ForwardRef as ReactComponent };